import React, { useState, useRef } from "react"

import { Modal } from "components"
import { isInPosDevice, ObjectValues, onlyPositiveNumber, roundNumber } from "utils"
import ApprovePaymentModalCard from "./ApprovePaymentModalCard"
import ApprovePaymentModalHeader from "./ApprovePaymentModalHeader"
import ApprovePaymentModalFooter from "./ApprovePaymentModalFooter"
import ApprovePaymentModalKeypad from "./ApprovePaymentModalKeypad"
import ApprovePaymentModalButton from "./ApprovePaymentModalButton"
import ApprovePaymentModalCashTypes from "./ApprovePaymentModalCashTypes"
import classes from "./index.module.scss"

const ApprovePaymentModal = props => {
  const {
    setOrders,
    selectedOrders,
    setSelectedOrders,
    openPaymentApproveModal,
    setOpenPaymentApproveModal
  } = props

  const [cashTypes, setCashTypes] = useState([])
  const [focusedCashType, setFocusedCashType] = useState(0)

  const paymentScrollRef = useRef(null)

  const handleChange = value => {
    setCashTypes(prev => {
      const notExists = !prev[focusedCashType]

      if (notExists) return prev

      const residue =
        onlyPositiveNumber(
          totalSelectedOrders - Number(value)
        )

      const result =
        prev.map((cashType, cIndex) =>
          cIndex === focusedCashType
            ?
            {
              ...cashType,
              amount: value
            }
            :
            {
              ...cashType,
              amount:
                residue !== 0 ? Number(residue).toFixed(2) : 0
            }
        )

      return result
    })
  }

  const initialCashtype = () => {
    isInPosDevice()
      ?
      setCashTypes([
        {
          amount: totalSelectedOrders,
          name: "کارتخوان",
          value: window.posName === "bpMellat" ? "کارتخوان به پرداخت" : "کارتخوان سداد",
          terminalName: "",
          isTerminal: true
        }
      ])
      :
      setCashTypes([
        {
          amount: totalSelectedOrders,
          name: "نقدی",
          value: "نقدی",
          terminalName: "",
          isTerminal: false
        }
      ])
  }

  const orders = ObjectValues(selectedOrders)

  const totalSelectedOrders =
    roundNumber(
      orders.reduce((t, order) =>
        t += order.totalBillAmount,
        0
      )
    )

  const amount =
    cashTypes[focusedCashType]?.amount || 0

  const numberOfSelectedOrders = orders.length

  return (
    <Modal

      className={classes["modal"]}
      show={openPaymentApproveModal}
      onEnter={initialCashtype}
      onHide={() => setOpenPaymentApproveModal(false)}
    >
      <div className={classes["container"]}>
        <ApprovePaymentModalHeader
          totalSelectedOrders={totalSelectedOrders}
        />

        <div
          ref={paymentScrollRef}
          className={classes["scroll"]}
        >
          {cashTypes.map((cashType, cIndex) =>
            <ApprovePaymentModalCard
              key={cIndex}
              cIndex={cIndex}
              cashType={cashType}
              setCashTypes={setCashTypes}
              focusedCashType={focusedCashType}
              setFocusedCashType={setFocusedCashType}
              totalSelectedOrders={totalSelectedOrders}
            />
          )}
          <ApprovePaymentModalFooter
            totalSelectedOrders={totalSelectedOrders}
            cashTypes={cashTypes}
          />
        </div>

        <ApprovePaymentModalCashTypes
          cashTypes={cashTypes}
          setCashTypes={setCashTypes}
          numberOfSelectedOrders={numberOfSelectedOrders}
          paymentScrollRef={paymentScrollRef}
          totalSelectedOrders={totalSelectedOrders}
          setFocusedCashType={setFocusedCashType}
        />

        <ApprovePaymentModalKeypad
          value={amount}
          onChange={handleChange}
        />

        <ApprovePaymentModalButton
          setOrders={setOrders}
          cashTypes={cashTypes}
          setCashTypes={setCashTypes}
          selectedOrders={selectedOrders}
          setSelectedOrders={setSelectedOrders}
          totalSelectedOrders={totalSelectedOrders}
          numberOfSelectedOrders={numberOfSelectedOrders}
          setOpenPaymentApproveModal={setOpenPaymentApproveModal}
        />
      </div>
    </Modal>
  )
}


export default ApprovePaymentModal